import React from 'react';
import { Favorite } from '@/components/Favorite';
import { BlockButton } from '@/components/BlockButton';
import defaultImage from '@/assets/images/no_image_found.png';

interface ListingProps {
  signedIn: boolean;
  listingDetails: any;
  blockCallback: () => void;
}

export function Listing({ signedIn, listingDetails, blockCallback }: ListingProps) {
  const startDate = listingDetails.start_date ? new Date(listingDetails.start_date) : null;
  const startDateText = startDate
    ? startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : 'None';
  const isPastDate = startDate && startDate < new Date();
  const moveInText = isPastDate ? 'Available now' : startDateText;

  return (
    <div className="col mb-4">
      <div className="card listing-card">
        {listingDetails.featured && (
          <a
            href={listingDetails.listing_path || listingDetails.route_path}
            target="_blank"
            className="featured badge rounded-pill bg-danger"
          >
            Featured
          </a>
        )}

        <Favorite
          signedIn={signedIn}
          favoritableType="Listing"
          favoritableId={listingDetails.id}
          favorited={listingDetails.favorited}
        />

        <BlockButton
          signedIn={signedIn}
          blockableType="Listing"
          blockableId={listingDetails.id}
          blocked={listingDetails.blocked}
          blockCallback={blockCallback}
        />

        <a href={listingDetails.listing_path || listingDetails.route_path} target="_blank">
          <img
            src={listingDetails.images.length ? listingDetails.images[0].url : defaultImage}
            className="card-img-top"
            alt={listingDetails.images.length ? listingDetails.images[0].alt : listingDetails.title}
          />
        </a>
        <div className="card-body">
          <div className="card-title">
            <a href={listingDetails.listing_path || listingDetails.route_path} target="_blank">
              {listingDetails.title}
            </a>
          </div>
          <div className="card-text">
            ${listingDetails.price} / {listingDetails.beds} beds
          </div>
          <div className="card-text">{listingDetails.layout}</div>
          <div className="card-text pb-2">Move In: {moveInText}</div>
          {listingDetails.posted_at && (
            <div className="card-text text-muted">
              Posted:{' '}
              {new Date(listingDetails.posted_at * 1000).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
